import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { API_URL } from '@/common/config'

const ApiService = {
  init () {
    Vue.use(VueAxios, axios)
    Vue.axios.defaults.baseURL = API_URL
  },

  call (path, params) {
    return Vue.axios.post(`/${path}`, params)
  },

  data (code, params) {
    return Vue.axios.post(`/datamethod`, {
      'code': code,
      'parameters': params
    })
  }
}

export default ApiService



// WEBPACK FOOTER //
// ./src/common/api.service.js